import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import CloseIcon from "@material-ui/icons/Close";
import LungChart from "../Chart/LungChart";
import { lungRiskCaculation } from "../../../../utils/calculate";

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: 22,
    fontWeight: 600,
    paddingTop: 12,
    paddingBottom: 12,
  },
  close: {
    cursor: "pointer",
  },
  contents: {
    padding: "16px 24px",
    height: 287,
  },
  resultSub: {
    marginTop: 4,
    marginBottom: 44,
    color: theme.palette.primary.main,
    "& h3": {
      margin: 0,
    },
  },
  resultDetail: {
    marginBottom: theme.spacing(4.5),
    "& h6": {
      marginBottom: theme.spacing(1),
    },
    "& .blue": {
      color: "#115bab",
      fontWeight: 700,
      fontSize: 20,
    },
    "& .blue2": {
      color: "#115bab",
      fontWeight: 700,
    },
    "& .black": {
      color: "#333333",
      fontWeight: 700,
      fontSize: 20,
    },
  },
  result1: {
    height: 250,
    marginTop: 12,
    marginBottom: 12,
    border: "1px solid rgb(0 0 0 / 26%)",
  },
  result1Title: {
    width: 150,
    textAlign: "center",
    borderRight: "1px solid rgb(0 0 0 / 26%)",
    height: "100%",
    fontSize: 20,
  },
  result1Total: {
    flex: 1,
    fontWeight: 500,
    fontSize: 20,
  },
  resultSub1: {
    color: theme.palette.primary.main,
  },
  coment: {
    color: "#747474",
    marginTop: 12,
    marginBottom: 18,
  },
  grapY: {
    fontSize: 14,
    color: "#333333",
    paddingLeft: 8,
  },
  grapTitle: {
    fontSize: 16,
    fontWeight: 600,
    marginBottom: 12,
  },
  numberResult: {
    borderRight: "1px solid rgb(0 0 0 / 26%)",
    width: "50%",
    height: "100%",
  },
  numberResult2: {
    flex: 1,
    width: "50%",
    height: "100%",
  },
  numberResultTitle: {
    color: "#747474",
    height: 60,
    background: "#f2f2f2",
    fontSize: 18,
  },
  totalCon: {
    height: 150,
    fontSize: 24,
  },
  leftContents: {
    width: 300,
  },
  rightContents: {
    width: 492,
  },
  leftTitle: {
    width: "50%",
    color: "#115bab",
    marginTop: 4,
    fontWeight: 700,
    marginBottom: 10,
    "& h3": {
      margin: 0,
    },
    "& .subtitle": {
      color: "#333333",
      fontWeight: 400,
      paddingTop: 12,
      fontSize: 14,
    },
  },
  rightTitle: {
    width: "50%",
    marginTop: 4,
    fontSize: 10,
    color: "#747474",
  },
  chart: {
    width: 492,
    height: 220,
  },
  footer: {
    paddingTop: theme.spacing(2.5),
    paddingBottom: theme.spacing(2.5),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
  footerButton: {
    fontSize: 16,
    fontWeight: 400,
  },
}));
const ye = ["y1", "y2", "y3", "y4", "y5"];
const LungResultForm = ({ total, age, handleClose, onReportGo }) => {
  const classes = useStyles();
  const fiveTotal = lungRiskCaculation(total);
  const [test, setTest] = React.useState(1);
  // const [per, sePer] = React.useState(0);
  const handleChange = (event) => {
    setTest(event.target.value);
  };
  // const checkPer = (total) => {
  //   let per = 0;
  //   if (0 <= total && total <= 15) {
  //     per = 0.18;
  //   } else if (16 <= total && total <= 30) {
  //     per = 0.2;
  //   } else if (31 <= total && total <= 45) {
  //     per = 0.2;
  //   } else if (46 <= total && total <= 53) {
  //     per = 0.36;
  //   } else if (54 <= total && total <= 62) {
  //     per = 0.45;
  //   } else if (63 <= total && total <= 81) {
  //     per = 0.55;
  //   } else if (82 <= total && total <= 92) {
  //     per = 0.85;
  //   } else if (93 <= total && total <= 107) {
  //     per = 1.19;
  //   } else if (108 <= total && total <= 123) {
  //     per = 1.84;
  //   } else {
  //     per = 5.45;
  //   }
  //   return per;
  // };

  return (
    <>
      <DialogTitle id="responsive-dialog-title">
        <Grid container alignItems="center" justify="space-between">
          <Grid className={classes.title}>폐암 위험도 자가진단 결과</Grid>
          <Grid className={classes.close} onClick={handleClose}>
            <CloseIcon style={{ fontSize: 24, color: "#969696" }} />
          </Grid>
        </Grid>
      </DialogTitle>
      <Grid
        container
        justify="space-between"
        direction="row"
        className={classes.contents}
      >
        <Box
          display="flex"
          flexWrap="wrap"
          alignItems="center"
          className={classes.leftContents}
        >
          <Grid container className={classes.resultSub}>
            <h3> 절대 위험도 </h3>
          </Grid>
          <Grid container direction="column" className={classes.resultDetail}>
            <Typography variant="h6"> 종합점수</Typography>
            <Typography>
              <span className="blue">{total}&nbsp;</span>
              <span className="black">/&nbsp;220점</span>
            </Typography>
          </Grid>
          <Grid container direction="column" className={classes.resultDetail}>
            <Typography variant="h6"> 5년 위험도</Typography>
            <Grid container direction="row" alignItems="center">
              <Box style={{ width: 150 }}>
                <select style={styles.selectbox} onChange={handleChange}>
                  <option value={1}>1년이내 생존률</option>
                  <option value={2}>2년차 생존률</option>
                  <option value={3}>3년차 생존률</option>
                  <option value={4}>4년차 생존률</option>
                  <option value={5}>5년차 생존률</option>
                </select>
              </Box>
              <Box style={{ width: 120 }}>
                <span className="blue2">{fiveTotal[ye[test - 1]]}%</span>
              </Box>
            </Grid>
          </Grid>
        </Box>
        <Box display="flex" flexWrap="wrap" className={classes.rightContents}>
          <Grid container justify="space-between">
            <Grid container direction="column" className={classes.leftTitle}>
              <h3> 상대 위험도 </h3>
              <Grid className="subtitle">발생빈도(건수)</Grid>
            </Grid>
            <Grid container justify="flex-end" className={classes.rightTitle}>
              * 출처 : KOSIS 보건복지부 암등록 통계 2020년
            </Grid>
          </Grid>
          <Box className={classes.chart}>
            <LungChart age={age} />
          </Box>
        </Box>
      </Grid>
      <DialogActions>
        <Grid
          container
          justify="center"
          alignItems="center"
          className={classes.footer}
        >
          <Button
            variant="contained"
            fullWidth
            color="primary"
            className={classes.footerButton}
            onClick={onReportGo}
          >
            결과 레포트 보기
          </Button>
        </Grid>
      </DialogActions>
    </>
  );
};

const styles = {
  selectbox: {
    position: "relative",
    width: "140px" /* 너비설정 */,
    border: "1px solid #999",
    zIndex: 1,
    padding: 6,
    "& :before": {
      content: "",
      position: "absolute",
      top: "50%",
      right: 15,
      width: 0,
      height: 0,
      marginTop: "-1px",
      // marginRight: "-10px",
      borderLeft: "5px solid transparent",
      borderRight: "5px solid transparent",
      borderTop: " 5px solid #333",
    },
    "& select": {
      width: "100%",
      height: "auto",
      lineHeight: "normal",
      fontFamily: "inherit",
      padding: ".8em .5em" /* 여백과 높이 결정 */,
      border: 0,
      opacity: 0,
      filter: "alpha(opacity=0)",
      appearance: "none",
    },
  },
};

export default LungResultForm;
